import { guardedClient as clientRequest } from '@repo/shared/helpers';
import {
	CompanyPortalSettings,
	companyPortalSettingSchema,
	CustomerThemeSettings,
	customerThemeSettingSchema,
	PersonalDashboardSettings,
	personalDashboardSettingSchema,
	GeneralSettings,
	generalSettingSchema,
	SettingsKey,
} from '@repo/shared/domain';

export const getSettings = async <T>(key: SettingsKey): Promise<T> => {
	const { body } = await clientRequest.get<undefined, T>(`/api/settings/${key}`, { schema: undefined });
	return body as T;
};

export const updateSettings = async <T>(key: SettingsKey, data: T): Promise<void> => {
	await clientRequest.put(`/api/settings/${key}`, data);
};
//TODO: fix types
export const getMultipleSettings = async (keys: SettingsKey[]) => {
	const joined = keys.join(',');
	const { body } = await clientRequest.get<undefined, Record<string, unknown>>(`/api/settings/multiple/${joined}`, {
		schema: undefined,
	});

	// Ensure all requested keys are available in the return; BE returns only keys that exist in the DB
	const results: Record<string, unknown> = {};
	for (const key of keys) {
		results[key] = body?.[key] ?? {};
	}
	return results;
};

export async function getGeneralSettings(): Promise<GeneralSettings> {
	const { body } = await clientRequest.get(`/api/settings/general`, {
		schema: generalSettingSchema,
	});
	return body;
}

export async function getCustomerThemeSettings(): Promise<CustomerThemeSettings> {
	const response = await clientRequest.get(`/api/settings/customer-theme`, {
		schema: customerThemeSettingSchema,
	});
	return response.body as CustomerThemeSettings;
}

export async function getCompanyPortalSettings(): Promise<CompanyPortalSettings> {
	const { body } = await clientRequest.get(`/api/settings/company-portal`, {
		schema: companyPortalSettingSchema,
	});
	return body;
}

export const getPersonalDashboardSettings = async (): Promise<PersonalDashboardSettings> => {
	const { body } = await clientRequest.get('/api/settings/personal-dashboard', {
		schema: personalDashboardSettingSchema,
	});
	return body;
};

export type TestCheckinatworkZoneResult = {
	zoneId: string;
	workplaceId: string;
	success: boolean;
	error?: string;
	warning?: string;
	resultCount?: number;
};

export type TestCheckinatworkResult = {
	success: boolean;
	tokenValid?: boolean;
	error?: string;
	zoneResults: TestCheckinatworkZoneResult[];
};

export const testCheckinatwork = async (data: Record<string, unknown>): Promise<TestCheckinatworkResult> => {
	const { body } = await clientRequest.post<Record<string, unknown>, TestCheckinatworkResult>(
		'/api/settings/checkinatwork/test',
		data,
	);
	return body;
};
